<template>
    <div class="custom bg-[#23242A]">
        <div class="flex xl:flex-row flex-col px-4 pt-4 bg-[#23242A] text-white">
            <div class="transition-all duration-100 ease-linear custom-left mr-2" :class="edit?'xl:w-[40%] w-full':'w-full'">
                <component :is="listType.component" :payload="listType.data" :resized="edit"
                    @toggleAddEdit="toggleAddEdit" @updatedEditItem="updatedEditItem" @togglePurchaseOrderUploadPop="togglePurchaseOrderUploadPop" @toggleProductImportPop="toggleProductImportPop" @toggleManitobaImportPop="toggleManitobaImportPop" @toggleMasterProductImportPop="toggleMasterProductImportPop" />
            </div>
            <div v-if="edit" class="xl:w-[60%] w-full custom-right transition-all duration-100 ease-linear">
                <edit-product v-if="edit" :asn="asn" :editItem="editItem" @close="closeEdit" />
            </div> 
        </div>
        <PurchaseOrderUploadPop v-if="purchaseOrderUploadPop" @close="closePurchaseOrderUpload" @uploadedPayload="uploadedPayload" />
        <ProductImportPop v-if="importProductPop" @close="closeImportProductPop" @uploadedProduct="uploadedProduct" />
        <ManitobaImportPop v-if="manitobaImportPop" @close="closeManitobaImportPop" @uploadedManitoba="uploadedManitoba" />
        <MasterProductImportPop v-if="masterProductImportPop" @close="closeMasterProductImportPop" @uploaded="uploadedMasterProduct" />
    </div>
</template>
<script lang="ts">
import { defineComponent, ref} from "vue";
import ProductList from '@/views/Products/MasterProduct/List/ProductList.vue'
import editProduct from '@/views/Products/MasterProduct/Edit/Edit.vue'
import PurchaseOrderUploadPop from '@/views/Products/MasterProduct/List/OrderUploadPop.vue'
import ProductImportPop from '@/views/Products/MasterProduct/List/ProductImportPop.vue'
import ManitobaImportPop from '@/views/Products/MasterProduct/List/ManitobaImportPop.vue'
import MasterProductImportPop from '@/views/Products/MasterProduct/List/MasterProductImportPop.vue'


export default defineComponent({
    components: {
        ProductList,
        editProduct,
        PurchaseOrderUploadPop,
        ProductImportPop,
        ManitobaImportPop,
        MasterProductImportPop
    },
    setup(){
        // list 
        const listType = ref({
            component: 'ProductList', 
            data: []
        })
        const purchaseOrderUploadPop = ref(false)
        const importProductPop = ref(false)
        const manitobaImportPop = ref(false)
        const masterProductImportPop = ref(false)

        const add = ref<boolean>(false)
        const edit = ref(false)
        const editItem = <any>ref({})

        return {listType, purchaseOrderUploadPop, importProductPop, manitobaImportPop, masterProductImportPop, add, edit, editItem}
    },
    mounted(){
        this.emitter.on("closeAddEdit", this.closeEdit);
    },
    beforeDestroy(){
        this.emitter.off("closeAddEdit", this.closeEdit);
    },
    methods: {
        toggleAddEdit(status){
            this.editItem = status.editItem
            this.edit = status.edit
            this.add = status.add
        },
        closeEdit(){
            this.edit = false
        },
        updatedEditItem(item){
            this.editItem = item
        },
        // ocs
        togglePurchaseOrderUploadPop(status){
            this.purchaseOrderUploadPop = status
        },
        closePurchaseOrderUpload(){
            this.purchaseOrderUploadPop = false
        },
        uploadedPayload(){
            this.closePurchaseOrderUpload()
        },
        // alberta
        toggleProductImportPop(status){
            this.importProductPop = status
        },
        closeImportProductPop(){
            this.importProductPop = false
        },
        uploadedProduct(){
            this.closeImportProductPop()
        },
        // manitoba
        toggleManitobaImportPop(status){
            this.manitobaImportPop = status
        },
        closeManitobaImportPop(){
            this.manitobaImportPop = false
        },
        uploadedManitoba(){
            this.closeManitobaImportPop()
        },
        toggleMasterProductImportPop(status){
            this.masterProductImportPop = status
        },
        closeMasterProductImportPop(){
            this.masterProductImportPop = false
        },
        uploadedMasterProduct(){
            this.closeMasterProductImportPop()
        }
    }
})
</script>